import { type RefObject, useEffect } from 'react';

type Params = {
  elementRef: RefObject<HTMLElement | null>;
  listener: (event: Event) => void;
};

const getParentElements = (element: HTMLElement, parents: HTMLElement[] = []): HTMLElement[] => {
  const parent = element.parentElement;
  return parent ? getParentElements(parent, [...parents, parent]) : parents;
};

export const useScrollListener = ({ elementRef, listener }: Params): void => {
  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    const elements = [element, ...getParentElements(element)];
    elements.forEach(elementItem => elementItem.addEventListener('scroll', listener));
    return () => {
      elements.forEach(elementItem => elementItem.removeEventListener('scroll', listener));
    };
  }, [elementRef, listener]);
};
